<template>
   <div class="custom-cursor"></div>
  <div @scroll="handleScroll" id="main">
    <Header/>
    <Transition mode="out-in" name="fade-slide">
      <RouterView />
    </Transition>
    <Footer/>
    <!-- <ResponsiveHeader v-if="activeResponsiveHeader"/> -->
   <Transition name="arrow">
    <div @click="scrollTop" v-if="activeArrow" class="scroll-arrow">↑</div>
   </Transition>
  </div>
</template>






<script>
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      activeArrow: false,
      activeResponsiveHeader: false
    }
  },
  methods: {
    handleScroll() {
      const scrollPosition = document.querySelector('#main').scrollTop;
      this.activeArrow = scrollPosition >= 10;
    },
    scrollTop() {
      document.querySelector('#main').scrollTop = 0;
    },
    windowWidth() {
      this.activeResponsiveHeader = window.innerWidth < 700;
    },
    updateCursor(event) {
    const cursor = document.querySelector('.custom-cursor');
    cursor.style.left = `${event.pageX}px`;
    cursor.style.top = `${event.pageY}px`;
  }
  },
  mounted() {
    this.windowWidth(); 
    window.addEventListener('resize', this.windowWidth);
    window.addEventListener("mousemove", this.updateCursor);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.windowWidth);
    window.removeEventListener("mousemove", this.updateCursor);
  }
}
</script>









<style>



@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');


.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 1s cubic-bezier(0.23, 1, 0.320, 1);
}

.fade-slide-enter-from,
.fade-slide-leave-to {
transform:scale(0.75);/*  rotateX(60deg) rotateY(25deg) translateX(75vw); */
  opacity: 0;
}



@font-face {
  font-family: 'Horizon';
  src: url('/public/font/horizon.otf');
}

@font-face {
  font-family: 'Horizon Outline';
  src: url('/public/font/horizon_outlined.otf');
}


:root {
  --bg-color-smooth-dark-grey-1: radial-gradient(circle,
      rgba(53, 51, 54, 1) 0%,
      rgba(0, 0, 0, 1) 100%);
  --bg-color-smooth-dark-grey-2: radial-gradient(circle,
      rgba(0, 0, 0, 1) 50%,
      rgba(45, 52, 54, 1) 100%);
  --bg-color-smooth-dark-grey-conic: conic-gradient(from 338deg at 50% 50%,
      #000000 0%,
      #696b74 23%,
      #000000 75%);


    --gold-gradient: linear-gradient(90deg, #ecc43f,#faf08d,#ddac16,#f9f197);  

  /**   BORDER - RADIUS    **/



  --circle-radius: 100px;
  --radius-4: 4px;
  --radius-8: 8px;
  --radius-12: 12px;
  --radius-16: 16px;
  --radius-20: 20px;






  /**   FONT - WEIGHT    **/


  --font-weight-extrabold: 900;
  --font-weight-black: 800;
  --font-weight-bold: 700;
  --font-weight-midbold: 500;
  --font-weight-light: 300;
  --font-weight-extralight: 100;








  /**   PRIMARY COLORS   **/
  --hard-blue:#141428;
  --light-blue:#1D1D2C;
  --white-text:#ECECEC;
  --black: #000000;
  --gray: #5a6a79;
  --white: #ffffff;
  --yellow-white: #f3eabb;








  /**   BACKGROUNDS    **/


  --bck: rgb(0, 0, 0);
  --transparent-bck: rgba(0, 0, 0, 0.2);
  --gray-hover: rgba(90, 106, 121, 0.2);
  --gray-hover-1: rgba(90, 106, 121, 0.3);
  --gray-hover-2: rgba(90, 106, 121, 0.5);
  --gray-hover-3: rgba(90, 106, 121, 0.6);
  --sub-text:#7B7981







  /**   BORDERS   **/

  /**  DOUBLE BORDERS  **/

  --double-gray: 0.5rem double var(--gray);
  --double-white: 0.5rem double var(--white);
  --double-black: 0.5rem double var(--black);


  /**  SOLID BORDERS  **/
  --transparent-gray-border: 0.1rem solid rgba(90, 106, 121, 0.2);
  --light-yellow-white-border:0.1rem solid var(--yellow-white);
  --light-gray-border: 0.1rem solid var(--gray);
  --light-white-border: 0.1rem solid var(--white);
  --light-black-border: 0.1rem solid var(--black);



/**  FONT  **/
  --font-text:'Montserrat','Roboto Flex';
  --font-title: 'Montserrat','Roboto Flex';
  --font-button: 'Montserrat','Roboto Flex';
  --font-number-title: 'Horizon';
  --font-number-title-outlined: 'Horizon Outline';




 /**  BOX-SHADOW  **/
 --box-shadow-1:0px 0px 0px 1px var(--gray-hover-1),0px 6px 20px -4px rgba(0, 0, 0, 0.25);





  /** BLUR **/

  --bck-blur: blur(10px);
}


.custom-cursor {
  position: fixed;
  width: 18px;
  height: 18px;
  background-color: var(--yellow-white);
  border-radius: 50%;
  pointer-events: none;
  transform: translate(-50%, -50%);
  transition: transform 0.15s ease-out, background-color 0.3s ease;
  /* Ajoute une ombre portée lumineuse */
  box-shadow: 0 0 6px var(--yellow-white), 0 0 10px var(--yellow-white);
  mix-blend-mode: difference; /* Permet une meilleure lisibilité sur tout type de fond */
  z-index: 100000;
}


#main {
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.span{
  color:var(--gray);
  font-weight: 700;
  font-size: 1.2rem;
}

::selection {
  background: var(--yellow-white);
  color: var(--black);
}

select{
  font-family: var(--font-button);
  background: var(--yellow-white);
  padding:0.8rem 1rem;
  border:none;
  font-size: 1.33rem;
  color:var(--black);
  font-weight: 700;
}

select:focus{
 border:1px solid var(--black);
}

select option{
  font-weight: 700;
  background:var(--yellow-white);
  border:1px solid white;
}

* input::placeholder,textarea::placeholder{
  color:var(--gray);
  font-family: var(--font-text);
  font-weight: 700;
}

input[type="text"],input[type='email'],textarea {
  font-family: var(--font-text);
  font-weight: var(--font-weight-bold);
  color: var(--gray);
  letter-spacing: 1px;
  font-size: 1.8rem;
  padding: 1.2rem 1rem;
  border-radius: 5px 5px 0 0;
  display: flex;
  align-items: center;
  background: var(--yellow-white);
  border: var(--light-gray-border);
  transition: 0.1s cubic-bezier(0.215, 0.610, 0.355, 1);
}

input[type="text"]:focus,input[type="email"]:focus,textarea:focus{
  border-bottom: 4px solid var(--gray);
}

input,select,textarea{
  outline:none
}

p {
  font-size: 1.75rem;
  font-weight: 400;
  color:var(--white-text);
}

a {
  color: var(--white-text);
  transition: 0.2s ease-in;
}

u {
  text-decoration: underline;
  font-weight: var(--font-weight-midbold);
  padding-right: 0.45rem;
  font-family: var(--font-text);
  color: var(--yellow-white);
  letter-spacing: 0;
  font-size: 1.65rem;
}

h1,h2,h3,h4 {
  letter-spacing:-1px;
}

h4 {
  font-size: 2.5rem;
  font-family: var(--font-text);
}

h3 {
  font-size: 3rem;
  font-family: var(--font-title);
}

h2 {
  font-size: 5rem;
  font-weight: var(--font-weight-bold);
}

h1 {
  font-size: 7.5rem;
  color: var(--gray);
  font-weight: var(--font-weight-extrabold);
  text-transform: uppercase;
}

h1,h2,h3{
  text-transform: uppercase;
}

h1,
h2 {
  font-family: var(--font-title);
  color: rgb(90, 106, 121);
}

h3,
h4 {
  color: var(--yellow-white);
  letter-spacing: -0.5px;
  font-weight: 700;
}

a,button{
  cursor: none !important;
}

button {
  font-family: var(--font-button);
  font-weight: 700;
  backdrop-filter: blur(8px);
  border-radius: 40px;
  padding: 1rem 4rem;
  background: var(--hard-blue);
  color: var(--white-text);
  border: 0;
  box-shadow: var(--box-shadow-1);
  transition:all 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  white-space: nowrap;
  font-size: 1.33rem;
}


button:hover {
  background: var(--gray-hover-1);
  /* color:var(--black); */
  /* box-shadow: 0px 0px 0px 2px #141428, 0px 0px 0px 4px var(--yellow-white); */
}

.plus {
  transition:all 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86); ;
  filter: invert(1);
  width: 1.75rem;
  margin-left: 0.75rem;
}





body {
  font-family: var(--font-text);
  background: var(--light-blue);
  color: rgb(245, 245, 245);
  overflow-x: hidden;
  min-height: 100vh;
  cursor: none !important;
}

*,
*::before,
*::after {
  padding: 0;
  margin: 0;
  list-style-type: none;
  text-decoration: none;
  scroll-behavior: smooth;
  box-sizing: border-box;
}

html {
  font-size: 10px;
}

hr {
  background: var(--gray-hover-1);
  height: 1px;
  border: 0;
  width: 100%;
}

.invert{
  filter:invert(1)
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-column-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.flex {
  display: flex;
}

.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}

.gray {
  color: var(--gray);
}

.uppercase {
  text-transform: uppercase;
}

.logo {
  transition: 0.1s ease-out;
}

.logo:hover {
  transform: scale(1.075);
}

.gray-bck {
  background: var(--gray);
  font-family: var(--font-button);
  padding: 5px 6px;
  margin-bottom: 1.15rem;
  transition: 0.2s cubic-bezier(0.47, 0, 0.745, 0.715);
  border-radius: 4px;
  font-weight: 700;
  font-size: 1.35rem;
}

.header-links,.footer-links {
  font-weight: 600;
}

.footer-links:hover,.header-links:hover {
    font-weight: 700;
    color: var(--yellow-white)
}










/* SCROLLBAR CSS */

::-webkit-scrollbar {
  width: 10px;
  background-color: #000000;
}

::-webkit-scrollbar-thumb {
  border: 3px solid rgb(0, 0, 0);
  transition: background 0.7s ease;
  cursor: grab;
  background: var(--yellow-white);
  border-radius: 20px;

}

::-webkit-scrollbar-track {
  background-color: #000000;
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--gray);
}





















/* SCROLL ARROW CSS */

.arrow-enter-active,
.arrow-leave-active {
  transition: all 0.35s cubic-bezier(0.23, 1, 0.320, 1);
}

.arrow-enter-from,
.arrow-leave-to {
  opacity: 0;
  transform: translateY(-25vh) scale(0.5);
}



.scroll-arrow {
  position: fixed;
  font-family: var(--font-button);
  bottom: 20px;
  right: 30px;
  background: var(--hard-blue);
  box-shadow: var(--box-shadow-1);
  font-size: 2rem;
  width: 5rem;
  height: 5rem;
  z-index: 10000;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.scroll-arrow:hover {
  color:var(--hard-blue);
  background: var(--yellow-white) !important;
  box-shadow: 0px 0px 0px 2px #141428, 0px 0px 0px 4px var(--yellow-white);
}





















/*MEDIA QUERIES*/

@media (max-width:1100px) {
  html {
    font-size: 9.5px;
  }
}

@media (max-width:900px) {
  html {
    font-size: 9px;
  }
}

@media (min-width: 1400px) {
  h1 {
    font-size: 7.5rem;
  }
  h2 {
    font-size: 4rem;
  }
  h3 {
    font-size: 2rem;
  }
  h4 {
    font-size: 1.5rem;
  }
}

/* Écrans larges (1100px - 1400px) */
@media (max-width: 1400px) {
  h1 {
    font-size: 6rem;
  }
  h2 {
    font-size: 3.5rem;
  }
  h3 {
    font-size: 1.8rem;
  }
  h4 {
    font-size: 1.4rem;
  }
}

/* Tablettes et petits écrans (768px - 1100px) */
@media (max-width: 1100px) {
  h1 {
    font-size: 5rem;
  }
  h2 {
    font-size: 3rem;
  }
  h3 {
    font-size: 1.75rem;
  }
  h4 {
    font-size: 1.3rem;
  }
  /* .custom-cursor,.swamp-trail {
    display: none;
  } */
}

/* Mobiles (600px - 768px) */
@media (max-width: 768px) {
  h1 {
    font-size: 4rem;
  }
  h2 {
    font-size: 2.5rem;
  }
  h3 {
    font-size: 1.6rem;
  }
  /* .custom-cursor,.swamp-trail {
    display: none;
  } */
}

/* Petits mobiles (moins de 600px) */
@media (max-width: 600px) {
  h1 {
    font-size: 3rem;
  }
  h2 {
    font-size: 2rem;
  }
  h3 {
    font-size: 1.5rem;
  }
  .custom-cursor,.swamp-trail {
    display: none;
  }
}

/* Très petits écrans (moins de 400px) */
@media (max-width: 400px) {
  h1 {
    font-size: 2.5rem;
  }
  h2 {
    font-size: 1.75rem;
  }
  h3 {
    font-size: 1.3rem;
  }
}





</style>
